export const MAX_GROUP_NAME = 48;
export const MAX_GROUP_DESCRIPTION = 500;
export const MAX_GROUP_LINK = 150;
